
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.8 6.8H7.2a.4.4 0 00-.4.4v9.6c0 .22.18.4.4.4h9.6a.4.4 0 00.4-.4V7.2a.4.4 0 00-.4-.4zm-.4 9.6H7.6V7.6h8.8v8.8z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm0 23.2C5.814 23.2.8 18.186.8 12 .8 5.814 5.814.8 12 .8 18.186.8 23.2 5.814 23.2 12c-.007 6.183-5.017 11.193-11.2 11.2z","fill":"#00003C"}})])
          )
        }
      }
    